module.exports = __webpack_public_path__ + "static/media/Avatar6.bc95746d.svg";